import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { isEmpty, cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { usePOTemplateOrderState } from '../AddPOTemplateProvider';
import CustomDetails from '../DetailFolder/CustomDetails';

function CustomSection({ element, eleIndex, dropLocation, fromForm }) {
  const [customData, setCustomData] = useState(null);
  const [forEditData, setForEcitData] = useState(null);
  const { deleteCard, modfiyReqAndEnable, changeLabel, poTemplateState, setPOTemplateState } = usePOTemplateOrderState();
  const { t } = useTranslation('common');

  const cardRef = useRef(null);

  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  const [{ cardOver, item }, drop] = useDrop({
    accept: 'container',
    drop: () => {
      dropLocation(eleIndex, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      cardOver: monitor.isOver(),
    }),
  });

  drop(cardRef);

  useEffect(() => {
    if (!isEmpty(element)) {
      setCustomData({ ...element });
    }
  }, [element]);

  useEffect(() => {
    if (!isEmpty(customData)) {
      const updatedData = cloneDeep(customData);
      updatedData.columns = customData?.columns?.map((arrEle) => {
        return arrEle.filter((e) => e?.id);
      });
      setForEcitData(updatedData);
    }
  }, [customData]);

  const changePosition = (item, index, i, eleIndex) => {
    if (eleIndex !== item?.eleIndex) {
      const dragedItem = item?.col;
      const newColumns = customData?.columns;
      const rightSide = poTemplateState?.rigthColumn;
      const oldColumns = rightSide?.templateJsonSchema[item?.eleIndex]?.columns;
      newColumns[index].splice(i, 0, dragedItem);
      oldColumns[item?.index].splice(item?.i, 1);
      setPOTemplateState((oldData) => ({ ...oldData, rigthColumn: rightSide }));
      setCustomData((previousData) => ({
        ...previousData,
        columns: newColumns,
      }));
    } else {
      const dragedItem = item?.col;
      const newColumns = customData?.columns;
      newColumns[index].splice(i, 0, dragedItem);
      if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
        newColumns[item?.index].splice(item?.i, 1); // very Important to be after new item is added
      } else {
        newColumns[item?.index].splice(item?.i + 1, 1);
      }
      setCustomData((previousData) => ({
        ...previousData,
        columns: newColumns,
      }));
    }
  };

  const onChangeCustom = (value, label, i, index) => {
    const template = [...customData.columns];
    if (template[index][i].key !== 'Dropdown' && template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        if (template[index][i].key === 'Ratio_Button') {
          return { ...e, value: false };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setCustomData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div ref={cardRef}>
        {cardOver && <div className="potemplate-drag-placeholder">{t('COMPANY_DETAILS.DROP_SECTION')}</div>}
        <Card className="listing-card">
          <Card.Header className={`px-2 py-2 bgcolor-dark ${fromForm && 'd-flex'}`}>
            <strong onClick={() => changeLabel(customData, eleIndex)}>{customData?.label?.length > 0 ? customData?.label : '-'}</strong>
            {fromForm && itemDragging?.type !== 'container' && (
              <>
                <button
                  className="btn btn-border ml-auto "
                  type="button"
                  name="edit"
                  aria-label="edit"
                  key={`${element?.key}_${eleIndex}_edit`}
                  onClick={() => {
                    modfiyReqAndEnable(forEditData, eleIndex);
                  }}
                >
                  <span className="icon-edit" />
                </button>
                <button
                  className="btn btn-border "
                  type="button"
                  aria-label="delete"
                  name="delete"
                  key={`${element?.key}_${eleIndex}_delete`}
                  onClick={() => deleteCard(eleIndex)}
                >
                  <span className="icon-delete" />
                </button>
              </>
            )}
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body>
              <Row className="py-3">
                {customData?.columns?.map((colEle, index) => {
                  return (
                    <Col lg={6} key={index}>
                      {colEle?.map((ele, i) => {
                        return (
                          <FormGroup key={ele?.key}>
                            <CustomDetails
                              col={ele}
                              index={index}
                              i={i}
                              changePosition={changePosition}
                              fromForm={fromForm}
                              eleIndex={eleIndex}
                              customData={customData}
                              onChange={onChangeCustom}
                            />
                          </FormGroup>
                        );
                      })}
                    </Col>
                  );
                })}
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    </DndProvider>
  );
}

export default CustomSection;
